import { useLiff } from '../contexts/LiffContext';
import { useEnsureMemberByLineId } from './queries/useUsers';
import { useTenant } from '../contexts/TenantContext';
import { getTenantIdFromUrl } from '../api/apiUtils';

/**
 * LIFF + 登入即加會員（僅主程式、有 tenant 時 ensure）。
 * 內部：useLiff() + useEnsureMemberByLineId(profile?.userId, profile?.displayName, { enabled: !!profile?.userId && !!effectiveTenantId })。
 * Lite 路由不使用此 hook，維持 useLiff() + LiffLoginGate。
 */
export function useLiffWithMember() {
  const liff = useLiff();
  const { tenantId } = useTenant();
  const urlTenantId = getTenantIdFromUrl();
  const effectiveTenantId = tenantId || urlTenantId || null;

  const {
    data: ensureMember,
    isLoading: isMemberLoading,
    error: ensureError,
    mutate: mutateEnsure,
  } = useEnsureMemberByLineId(liff.profile?.userId, liff.profile?.displayName, {
    enabled:
      !!liff.profile?.userId &&
      !!effectiveTenantId &&
      (liff.shouldUseLiff ? liff.isLoggedIn : true),
  });

  const isMemberReady = !isMemberLoading;

  return {
    ...liff,
    ensureMember,
    isMemberReady,
    isMemberLoading,
    ensureError,
    mutateEnsure,
  };
}
